<style lang="scss"></style>

<template>
	<div style="overflow: auto;height: 100%;position: relative;display: flex;flex-direction: column;">
		<div class="titleBar" style="display: flex;align-items:center ;position: sticky;top: 0;padding: 20px;">
			<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
			<p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
				{{ $t('FF240') }}
			</p>
		</div>


		<div ref="chartContent" :style="{ height: chartHeight + 'px' }" style="padding:0px 20px 20px 20px;flex:1;display: flex;justify-content: space-between;">

			<div style="flex:1;display: flex;flex-direction: column;justify-content: space-between;" :style="{ height: chartHeight + 'px' }">
				<div style="width: 100%;background: rgba(75, 112, 151, 0.1);border: 0.5px solid rgba(72, 109, 147, 0.3);display: flex;align-items: center;padding:4px 12px ;justify-content: space-between;">
					<div style="display: flex;align-items: center;">
						<div style="background: #0882FF;width: 16px;height: 16px;"></div>
						<p style="font-weight: 400;font-size: 16px;color: #C6C6C6;margin-left: 12px;">{{ $t('znh') }}</p>
					</div>
					<div style="display: flex;align-items: center;">
						<p style="font-weight: 700;font-size: 18px;color: #FFFFFF;">{{ datas.realtimeEnergyConsumption[0] }}</p>
						<p style="font-weight: 400;font-size: 16px;margin-left: 4px;color: #C6C6C6;">kWh</p>
					</div>
				</div>

				<div style="width: 100%;background: rgba(75, 112, 151, 0.1);border: 0.5px solid rgba(72, 109, 147, 0.3);display: flex;align-items: center;padding:4px 12px ;justify-content: space-between;">
					<div style="display: flex;align-items: center;">
						<div style="background: #05FB90;width: 16px;height: 16px;"></div>
						<p style="font-weight: 400;font-size: 16px;color: #C6C6C6;margin-left: 12px;">{{ $t('ztpl') }}</p>
					</div>
					<div style="display: flex;align-items: center;">
						<p style="font-weight: 700;font-size: 18px;color: #FFFFFF;">{{ (datas.realtimeEnergyConsumption[0] * 0.533).toFixed(2) }}</p>
						<p style="font-weight: 400;font-size: 16px;margin-left: 4px;color: #C6C6C6;">kg-CO2</p>
					</div>
				</div>

				<div style="width: 100%;background: rgba(75, 112, 151, 0.1);border: 0.5px solid rgba(72, 109, 147, 0.3);display: flex;align-items: center;padding:4px 12px ;justify-content: space-between;">
					<div style="display: flex;align-items: center;">
						<div style="background: #0882FF;width: 16px;height: 16px;"></div>
						<p style="font-weight: 400;font-size: 16px;color: #C6C6C6;margin-left: 12px;">{{ $t('dmnh') }}</p>
					</div>
					<div style="display: flex;align-items: center;">
						<p style="font-weight: 700;font-size: 18px;color: #FFFFFF;">{{ datas.realtimeMoldEnergyCon[0] }}</p>
						<p style="font-weight: 400;font-size: 16px;margin-left: 4px;color: #C6C6C6;">{{ $t('kwh/mo') }}</p>
					</div>
				</div>

				<div style="width: 100%;background: rgba(75, 112, 151, 0.1);border: 0.5px solid rgba(72, 109, 147, 0.3);display: flex;align-items: center;padding:4px 12px ;justify-content: space-between;">
					<div style="display: flex;align-items: center;">
						<div style="background: #05FB90;width: 16px;height: 16px;"></div>
						<p style="font-weight: 400;font-size: 16px;color: #C6C6C6;margin-left: 12px;">{{ $t('dmtpl') }}</p>
					</div>
					<div style="display: flex;align-items: center;">
						<p style="font-weight: 700;font-size: 18px;color: #FFFFFF;">{{ (datas.realtimeMoldEnergyCon[0] * 0.533).toFixed(2) }}</p>
						<p style="font-weight: 400;font-size: 16px;margin-left: 4px;color: #C6C6C6;">{{ $t('kg-CO2/mo') }}</p>
					</div>
				</div>

				<div style="width: 100%;background: rgba(75, 112, 151, 0.1);border: 0.5px solid rgba(72, 109, 147, 0.3);display: flex;align-items: center;padding:4px 12px ;justify-content: space-between;">
					<div style="display: flex;align-items: center;">
						<div style="background: #0882FF;width: 16px;height: 16px;"></div>
						<p style="font-weight: 400;font-size: 16px;color: #C6C6C6;margin-left: 12px;">{{ $t('dwclhdl') }}</p>
					</div>
					<div style="display: flex;align-items: center;">
						<p style="font-weight: 700;font-size: 18px;color: #FFFFFF;">{{ datas.realtimeMoldMaterialCon[0] }}</p>
						<p style="font-weight: 400;font-size: 16px;margin-left: 4px;color: #C6C6C6;">kWh/kg</p>
					</div>
				</div>

			</div>

		</div>

	</div>
</template>
<script type="text/javascript">
export default {
	name: 'web_monitor_die_caster_pentu',
	components: {

	},
	props: {
		datas: {
			type: Object,
			default: () => {
				return {
				}
			}
		}
	},
	watch: {
		datas(newValue, oldValue) {
			if (this.utils.isEqual(newValue, oldValue)) {
				return;
			}
		}
	},
	data() {
		return {
			timmer: null,
			chartHeight: 0,
			chart: null,
			option: null,

		};
	},
	created() {
		this.timmer = setInterval(() => {
		}, 120000)
	},
	mounted() {
		this.utils.event_hub.$on('RESIZE', () => {
			this.resize();
		});
		this.resize();
	},

	destroyed() {
		clearInterval(this.timmer)
	},
	methods: {

		resize() {
			//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
			setTimeout(() => {
				if (!this.$refs.chartContent) {
					return;
				}
				this.chartHeight = this.$refs.chartContent.offsetHeight - 20;
				setTimeout(() => {
					if (this.chart != null) {
						this.chart.resize();
					}
				}, 0);
			}, 500);
		}
	}
};
</script>
